module.exports = __webpack_public_path__ + "img/logo_px40_clara.10010c6f.png";